<div id="remote-power-details-table" class="table-wrapper" *ngIf="detailsTableData?.length">
  <div class="table-content">
    <p-table
      class="rp-results-table"
      [value]="detailsTableData"
      [tableStyle]="{ 'width': '100%', 'table-layout': 'auto' }"
    >
      <ng-template pTemplate="header">
        <tr>
          <th
            *ngFor="let header of headers"
            class="col-auto"
            [pSortableColumn]="header"
          >
            <div class="thHeaderFlex">
              <div class="cellClamp headerClamp thHeaderTitle" [title]="(header | headerParser)">
                {{ header | headerParser }}
              </div>
              <p-sortIcon class="thSortIcon" [field]="header"></p-sortIcon>
            </div>
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
        <tr
          (click)="onRowSelect(item, rowIndex)"
          [ngClass]="{ 'p-highlight': item?._selected }"
        >
          <td *ngFor="let header of headers" class="col-auto">
            <div class="cellClamp" [title]="item[header]">
              {{ item[header] }}
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>

    <button class="button action-btn" (click)="onSubmit()" type="submit">
      Zaključi izbiro
    </button>
  </div>
</div>